module.exports = ".add-files-btn {\n  float: right; }\n\n:host {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.actions {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\n.container {\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/files/dialog/dialog.component.scss
// module id = ./src/app/shared/components/files/dialog/dialog.component.scss
// module chunks = main